import { WarehouseItemPhotoAction } from "@redotech/cockroachdb-codegen/tables/fulfillment/warehouse-item-photo-action";
import {
  photoInstructionsIdFormat,
  photoInstructionStepIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";
import { PhotoInstructionsSchema } from "./item-work-request-types";

export const listPhotoInstructions = {
  name: "listPhotoInstructions" as const,
  input: z.object({}),
  output: z.object({ instructions: z.array(PhotoInstructionsSchema) }),
};

/** Creates when `id` is absent, replaces the set and its steps when present. */
export const savePhotoInstructions = {
  name: "savePhotoInstructions" as const,
  input: z.object({
    id: photoInstructionsIdFormat.schema.nullish(),
    description: z.string().min(1),
    action: z.enum(WarehouseItemPhotoAction),
    steps: z.array(
      z.object({
        id: photoInstructionStepIdFormat.schema.nullish(),
        guidance: z.string(),
        examplePhotoUrl: z.string().nullish(),
      }),
    ),
  }),
  output: z.object({ instructions: PhotoInstructionsSchema }),
};

export const deletePhotoInstructions = {
  name: "deletePhotoInstructions" as const,
  input: z.object({ id: photoInstructionsIdFormat.schema }),
  output: z.null(),
};
